import React, { Fragment } from 'react';

//Component
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';
import PageTitle from '../Layout/PageTitle';
import VideoPopup from '../Element/VideoPopup';
//Images
import bnr1 from './../../images/line2.png';
import bnr2 from './../../images/background/about-2.jpg';
import team1 from './../../images/team/psir.jpg';

const TeachersDetail = () => {
	// const sendEmail = (e) => {
	// 	e.preventDefault();
	// 	//emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_USER_ID')
	// 	emailjs.sendForm('service_zubfdvh', 'template_iy1pb0b', e.target, 'user_FvNIKVJ7om2PphifhzMm2')
	// 	  .then((result) => {
	// 		  console.log(result.text);
	// 	  }, (error) => {
	// 		  console.log(error.text);
	// 	  });
	// 	  e.target.reset()
	//  };

	return (
		<Fragment>
			<Header />
			<div className="page-content">
				<PageTitle motherMenu="Principal" />
				<div className="content-block">
					<div className="section-full bg-white content-inner-2 teacher-info section-bg-soft" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
						<div className="container">
							<div className="row">
								<div className="col-lg-6 col-md-12 col-sm-12 m-b15">
									<div className="teacher-meida">
										<img src={team1} alt="" />
									</div>
								</div>
								<div className="col-lg-6 col-md-12 col-sm-12 teacher-content align-self-center">
									<h2 className="teacher-title">RAJESH BAGHEL</h2>
									<span className="teacher-coures">Principal</span>
									<p className="m-b15">
										Dear parents,
										Our children are our invaluable future assets. Changing times have made our children sensitive and we need to be alert and cognizant. The school  enables us to be rightly informed. This is a medium through which effective communication is facilitated between the school and the parents. We at the school, strive towards the overall development of our student and this can be possible with your continuous support. To prevent our students from being unduly stressed, we must identify their innate qualities, educational capabilities, and challenges to bring out their best and this can be done by regular follow up. Please ensure that your child come to school regularly and used effectively.
									</p>
									{/* <ul className="list-inline">
											<li><Link to={"#"} ><i className="fa fa-facebook"></i></Link></li>
											<li><Link to={"#"} ><i className="fa fa-google-plus"></i></Link></li>
											<li><Link to={"#"} ><i className="fa fa-linkedin"></i></Link></li>
											<li><Link to={"#"} ><i className="fa fa-instagram"></i></Link></li>
											<li><Link to={"#"} ><i className="fa fa-twitter"></i></Link></li>
										</ul> */}
								</div>
							</div>
						</div>
					</div>
					<div className="section-full bg-white content-inner-2 about-content bg-img-fix" style={{ backgroundImage: "url(" + bnr2 + ")" }}>
						<div className="container">
							<div className="row">
								<div className="col-lg-12 col-md-12 col-sm-12 col-12 " style={{ visibility: "visible", animationDuration: "2s", animationDelay: "0.2s", animationName: "fadeIn" }}>
									<div className="section-head text-center gallery-mpg">
										<div className="video-play">
											<VideoPopup />
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="section-full content-inner-2">
						<div className="container">
							<div className="row">
								<div className="col-lg-6 section-head">
									<h2 className="text-secondry">Education & Experience</h2>
									<p className="m-b0">Hello! I’m someone who believes in learning by doing. Over the past few years, I’ve gained hands-on experience in different areas that have helped me grow personally and professionally.</p>
								</div>
								<div className="row">
									{/* Left Side */}
									<div className="col-md-6">
										<div className="progress-section">
											<div className="progress-bx"><h6 className="title">B.Sc. Mathematics</h6></div>
											<div className="progress-bx"><h6 className="title">M.Sc. Mathematics</h6></div>
											<div className="progress-bx"><h6 className="title">B.ed.</h6></div>

										</div>
									</div>

									{/* Right Side */}
									<div className="col-md-6">
										<div className="progress-section">
											<div className="progress-bx"><h6 className="title">15 yrs experience</h6></div>
											<div className="progress-bx"><h6 className="title">5 Year Sarvodaya Higher Secondary School</h6></div>
											<div className="progress-bx"><h6 className="title">5 year Sunrise English Medium School</h6></div>
											<div className="progress-bx"><h6 className="title">3 Years BRIGHT FUTURE INSTITUTE OF MATHS AND SCIENCE</h6></div>
											<div className="progress-bx"><h6 className="title">2 Years KALAWAD ENGLISH MEDIUM SCHOOL</h6></div>
											<div className="progress-bx"><h6 className="title">5 Years UTTHAN LOK VIGYANA KENDRA</h6></div>
										</div>
									</div>
								</div>

								{/* <div className="row contact-box">
									<div className="section-head text-center col-md-12">
										<h2 className="text-secondry">Contact Me</h2>
										<p className="m-b0">Meh synth Schlitz, tempor duis single-origin coffee ea next level ethnic fingerstache fanny pack nostrud. Photo booth anim 8</p>
									</div>
									<div className="dzFormMsg"></div>
									<form method="post" className="dzForm col-md-12" ref={form} onSubmit={sendEmail}>
										<input type="hidden" value="Contact" name="dzToDo" />
										<div className="row">
											<div className="col-md-4 col-sm-4">
												<div className="form-group">
													<input name="name" type="text" required="required" className="form-control" placeholder="Enter your name" />
												</div>
											</div>
											<div className="col-md-4 col-sm-4">
												<div className="form-group">
													<input name="dzEmail" type="email" className="form-control" required="required"  placeholder="Your Email Address" />
												</div>
											</div>
											<div className="col-md-4 col-sm-4">
												<div className="form-group">
													<input name="dzOther[Phone]" type="text" required="required" className="form-control" placeholder="Phone" />
												</div>
											</div>
											<div className="col-md-12 col-sm-12">
												<div className="form-group">
													<textarea name="dzMessage" rows="4" className="form-control" required="required" placeholder="Your message here"></textarea>
												</div>
											</div>
											<div className="col-md-12 col-sm-12">
												<div className="form-group">
													<div className="g-recaptcha" data-sitekey="6LefsVUUAAAAADBPsLZzsNnETChealv6PYGzv3ZN" data-callback="verifyRecaptchaCallback" data-expired-callback="expiredRecaptchaCallback"></div>
													<input className="form-control d-none" style={{display:"none"}} data-recaptcha="true" data-error="Please complete the Captcha" />
												</div>
											</div>
											<div className="col-md-12 col-sm-12 text-center">
												<button name="submit" type="submit" value="Submit" className="btn radius-xl btn-lg">Send Message<span></span></button>
											</div>
										</div>
									</form>
								</div>  */}

							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	)
}

function InputBlog() {
	return (
		<>
			<div className="col-md-4 col-sm-4">
				<div className="form-group">
					<input name="dzName" type="text" required="required" className="form-control" placeholder="Enter your name" />
				</div>
			</div>
			<div className="col-md-4 col-sm-4">
				<div className="form-group">
					<input name="dzEmail" type="email" className="form-control" required="required" placeholder="Your Email Address" />
				</div>
			</div>
			<div className="col-md-4 col-sm-4">
				<div className="form-group">
					<input name="dzOther[Phone]" type="text" required="required" className="form-control" placeholder="Phone" />
				</div>
			</div>
			<div className="col-md-12 col-sm-12">
				<div className="form-group">
					<textarea name="dzMessage" rows="4" className="form-control" required="required" placeholder="Your message here"></textarea>
				</div>
			</div>
		</>
	)
}
export { InputBlog };
export default TeachersDetail;